import stylesheetUrl from './compiled.static-styles-asset';
if (typeof document !== 'undefined' && !document.querySelector('link[data-static-styles-react]')) {
  const link = document.createElement('link');
  link.rel = 'stylesheet';
  link.href = stylesheetUrl;
  link.dataset.staticStylesReact = '';
  document.head.appendChild(link);
}
import { registerComposition } from '@terraindigital/static-styles-react';
registerComposition(["divider__hr-3lbafm","feedback-form__divider-19zby3"], "feedback-form__divider--merged-0jxxt2");
registerComposition(["divider__hr-3lbafm","fnol__divider-3vfsli"], "fnol__divider--merged-3kamyb");
registerComposition(["divider__hr-3lbafm","franchise-team-members__divider-2workk"], "franchise-team-members__divider--merged-05subx");
registerComposition(["divider__hr-3lbafm","icon-bullets__divider-2d0mks"], "icon-bullets__divider--merged-2bn2cd");
registerComposition(["divider__hr-3lbafm","icon-blurbs-slider__divider-0bx32j"], "icon-blurbs-slider__divider--merged-2owpq2");
registerComposition(["divider__hr-3lbafm","icon-blurbs-slider__divider-1pmbm3"], "icon-blurbs-slider__divider--merged-0qqqwh");
registerComposition(["divider__hr-3lbafm","split-text-banner__divider-1jcfu7"], "split-text-banner__divider--merged-2n54yt");
registerComposition(["divider__hr-3lbafm","text-banner__divider-13c4jm"], "text-banner__divider--merged-1u787l");
registerComposition(["close-button__button-33phjw","announcement-bar__closebutton-1id0kp"], "announcement-bar__closebutton--merged-2zgrd6");
registerComposition(["divider__hr-3lbafm","locations-index__divider-2y2yro"], "locations-index__divider--merged-18czfj");
export {};
